import React, { useState, useEffect } from 'react';
import { students } from '../data.js';
import { getAllBirthdaysSorted } from '../services/birthdayService.js';
import './BirthdayManager.css';

const BirthdayManager = () => {
  const [upcomingBirthdays, setUpcomingBirthdays] = useState([]);
  const [todaysBirthdays, setTodaysBirthdays] = useState([]);

  useEffect(() => {
    calculateBirthdays();
  }, []);

  const calculateBirthdays = () => {
    const today = new Date();
    const upcoming = [];
    const todaysStudents = [];

    students.forEach(student => {
      if (!student.birthDate) return;

      const birthDate = new Date(student.birthDate);
      const thisYear = today.getFullYear();
      const nextBirthday = new Date(thisYear, birthDate.getMonth(), birthDate.getDate());
      
      if (nextBirthday < today) {
        nextBirthday.setFullYear(thisYear + 1);
      }

      const daysUntil = Math.ceil((nextBirthday - today) / (1000 * 60 * 60 * 24));
      
      if (daysUntil === 0) {
        todaysStudents.push({
          ...student,
          age: thisYear - birthDate.getFullYear(),
          daysUntil: 0
        });
      } else if (daysUntil <= 7) {
        upcoming.push({
          ...student,
          age: thisYear - birthDate.getFullYear(),
          daysUntil,
          nextBirthday
        });
      }
    });

    upcoming.sort((a, b) => a.daysUntil - b.daysUntil);
    setUpcomingBirthdays(upcoming);
    setTodaysBirthdays(todaysStudents);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' });
  };

  return (
    <div className="birthday-manager">
      <div className="birthday-header">
        <h2>🎂 Doğum Günü Takibi</h2>
      </div>

      <div className="birthday-content">
          {/* Bugünkü Doğum Günleri */}
          {todaysBirthdays.length > 0 && (
            <div className="todays-birthdays">
              <h3>🎉 Bugün Doğum Günü Olanlar</h3>
              <div className="birthday-cards">
                {todaysBirthdays.map(student => (
                  <div key={student.id} className="birthday-card today">
                    <div className="student-avatar">
                      <img src={student.avatar} alt={student.name} />
                      <div className="birthday-badge">🎂</div>
                    </div>
                    <div className="student-info">
                      <h4>{student.name}</h4>
                      <p>{student.age} yaşında!</p>
                      <p className="birth-date">{formatDate(student.birthDate)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Yaklaşan Doğum Günleri */}
          <div className="upcoming-birthdays">
            <h3>📅 Yaklaşan Doğum Günleri (7 gün içinde)</h3>
            {upcomingBirthdays.length > 0 ? (
              <div className="birthday-list">
                {upcomingBirthdays.map(student => (
                  <div key={student.id} className="birthday-item">
                    <div className="student-avatar">
                      <img src={student.avatar} alt={student.name} />
                    </div>
                    <div className="student-info">
                      <h4>{student.name}</h4>
                      <p>{student.age} yaşına girecek</p>
                      <p className="birth-date">{formatDate(student.birthDate)}</p>
                    </div>
                    <div className="days-until">
                      <span className="days-number">{student.daysUntil}</span>
                      <span className="days-text">gün kaldı</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-birthdays">
                <p>Önümüzdeki 7 gün içinde doğum günü olan öğrenci bulunmuyor.</p>
              </div>
            )}
          </div>

          {/* Tüm Öğrencilerin Doğum Günleri */}
          <div className="all-birthdays">
            <h3>📋 Tüm Öğrenci Doğum Günleri</h3>
            <div className="birthday-list-all">
              {getAllBirthdaysSorted()
                .map(student => {
                  return (
                    <div key={student.id} className="birthday-item-small">
                      <div className="student-avatar-small">
                        <img src={student.avatar} alt={student.name} />
                      </div>
                      <div className="student-info-small">
                        <h5>{student.name}</h5>
                        <p>{formatDate(student.birthDate)} - {student.age} yaşında</p>
                        <p className="days-remaining">
                          {student.daysUntil === 0 ? (
                            <span className="today-badge">🎉 Bugün!</span>
                          ) : (
                            <span className="days-count">⏰ {student.daysUntil} gün kaldı</span>
                          )}
                        </p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
      </div>
    </div>
  );
};

export default BirthdayManager;